/**
 * pnr Table of prices component
 **/
import { Component, Input } from '@angular/core';
import { faEye, IconDefinition, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

//Vanilla JS
import { Yii } from "libraries/interfaces/Yii";
import _filter from 'lodash-es/filter';
import _isArray from 'lodash-es/isArray';
import _isString from 'lodash-es/isString';
import _join from 'lodash-es/join';
import _union from 'lodash-es/union';

import * as moment from 'moment';


@Component({

    selector: 'pnr-price-table',
    templateUrl: './pnrPriceTable.component.html',
    styleUrls: ['./pnrPriceTable.component.css']
})
export class PNRPriceTableComponent {

    public Yii = Yii;

    @Input()
    public priceData: any[];
    @Input()
    public farebasisData: any;
    @Input()
    public label: any;
    @Input()
    public details: any;
    @Input()
    public filter: any;
    @Input()
    public luggageData: any;
    @Input()
    public validityData: any;
    @Input()
    public faretypeData: any;
    @Input()
    public segmentList: any;
    @Input()
    public index: number;
    @Input()
    public sectors: any;

    public total: any = 0;
    public base: any = 0;
    public tax: any = 0;
    public valid: boolean = true;
    public now: any;
    public header: any;
    public showDetails: boolean;

    public travellersInfos: string;
    public farebasisInfos: any;
    public luggageInfos: any;

    public display: boolean = true;
    public TTC = Yii.t('wui-shared-js', 'TTC');
    public HT = Yii.t('wui-shared-js', 'HT');
    public Taxes = Yii.t('wui-shared-js', 'Taxes');

    public Typology = Yii.t('wui-shared-js', 'Typologie');

    public dateFormat = JSON.parse(sessionStorage.getItem('dateFormat'));

    //check Faretype type (string or array)
    public typeFaretype: string;

    public displayPopup: { show: boolean, data?: any } = { show: false };

    public iconEye: IconDefinition = faEye;

    public iconEyeSlash: IconDefinition = faEyeSlash;

    constructor() {
        //
    }

    public ngOnInit(): void {
        const nbData = _filter(this.priceData, (price) =>
            price.role === "Base" && price.target === this.filter).length;
        if (this.details !== 'details') { // if totals
            this.mapData();
        } else if (nbData !== 0 && this.details === 'details') { // if there is datas to display with this filter
            this.mapData();
        } else if (nbData === 0 && this.details === 'details') { // if there is no datas to display with this filter
            this.display = false;
        }

        //set validity
        if (this.validityData) {
            const nowDay = moment().dayOfYear();
            const nowYear = moment().year();

            const validityEndDay = moment(this.validityData.end, 'YYYY-MM-DD').dayOfYear();
            const validityEndYear = moment(this.validityData.end, 'YYYY-MM-DD').year();


            if (validityEndYear > nowYear) {
                this.valid = true;
            } else if (nowDay > validityEndDay) {
                this.valid = false;
            }
        }

        //set text for Header form segment list

        if (this.segmentList) {
            this.header = Yii.t('wui-shared-js', 'Tarification ') + this.index;

        }

        //check Faretype type (string or array)

        if (this.faretypeData && _isString(this.faretypeData)) {

            this.typeFaretype = 'string'; //is a string
        } else if (this.faretypeData && _isArray(this.faretypeData)) {


            this.typeFaretype = 'array'; //is not string, ie is an array
        }

        this.init2();

    }

    public init2() {
        //
    }

    public mapData(): void {
        if (this.details !== 'details') {
            const tempTotal: any = _filter(this.priceData, (price) => price.role === "Total")[0];
            this.total = tempTotal.total;
            const tempBase: any = _filter(this.priceData, (price) => price.role === "Base")[0];
            this.base = tempBase.total;
            const tempTax: any = _filter(this.priceData, (price) => price.role === "Tax")[0];
            this.tax = tempTax.total;
        } else {
            const baseObj: any = _filter(this.priceData, (price) =>
                price.role === "Base" && price.target === this.filter)[0];
            const taxObj: any = _filter(this.priceData, (price) =>
                price.role === "Tax" && price.target === this.filter)[0];
            this.base = baseObj.value;
            this.tax = taxObj.value;
            this.total = this.base + this.tax;

            const travellersList = _union(baseObj.traveller, taxObj.traveller);
            this.travellersInfos = _join(travellersList, ', ');

            //filter needed datas on filter
            this.farebasisInfos = _filter(this.farebasisData, { "traveller": travellersList });
            this.luggageInfos = _filter(this.luggageData, { "traveller": travellersList })[0];
        }
    }

    /** Show segment resume to help user to understand tarification */
    private showResumeSegment(segment: string) {
        if (this.displayPopup.show) {
            this.displayPopup = { show: false };
        } else {
            this.displayPopup = { show: true, data: segment };
        }

    }
}
